import React from "react";
import { TeachersUIProvider } from "./TeachersUIContext";
import { TeachersCard } from "./TeachersCard";

export function TeachersPage({
  noticeId
}) {
  return (
    <TeachersUIProvider noticeId={noticeId}>
      <TeachersCard />
    </TeachersUIProvider>
 );
}